interface PriceProps {
    value: string,
    unit: string
}
interface ViewTagProp {
    title: string,
    value: string
}
interface listBrandType {
    name: string,
    value: number
}

interface TradeMarkType {
    name: string,
    image:string,
}

interface CardType {
    name: string,
    image:string,
    price: string,
    priceOrigin: string,
    unit: string,
    date:number,
    id:number
}

export const listPrice:PriceProps[] = [
    {
        value:"100000",
        unit: "VNDC"
    },
    {
        value:"200000",
        unit: "VNDC"
    },
    {
        value:"500000",
        unit: "VNDC"
    },
    {
        value:"1000000",
        unit: "VNDC"
    },
    {
        value:"2000000",
        unit: "VNDC"
    }
]

interface Types {
    name: string,
    value: number
}

export const listPrice2:Types[] = [
    {
        name: "50.000",
        value: 50000
    },
    {
        name: "100.000",
        value: 100000
    },
    {
        name: "200.000",
        value: 200000
    },
    {
        name: "500.000",
        value: 500000
    },
    {
        name: "1.000.000",
        value: 1000000
    }
]

export const listBrand:listBrandType[] = [
    {
        name: "Tất cả",
        value: 0
    },
    {
        name: "Đồ uống",
        value: 1
    },
    {
        name: "Đồ ăn",
        value: 2
    },
    {
        name: "Giải trí",
        value: 3
    },
    {
        name: "Làm đẹp - Sức khoẻ",
        value: 4
    },
    {
        name: "Mua sắm",
        value: 5
    },
    {
        name: "Tiện ích",
        value: 6
    },
    {
        name: "Dịch vụ sân bay",
        value: 7
    }
]

export const ListformReceipt = [
    {
        label: 'Gửi qua Email',
        value: 'email',
    },
    {
        label: 'Gửi qua Zalo',
        value: 'zalo',
    }
]


export const ListRegion = [
    {
        label: "An Giang",
        value: 0,
    tokens: ''

    },
    {
        label: "Bà Rịa - Vũng Tàu",
        value: 1
    },
    {
        label: "Cần Thơ",
        value: 2
    },
    {
        label: "Bình Dương",
        value: 3
    },
    {
        label: "Bình Thuận",
        value: 4
    },
    {
        label: "Cà Mau",
        value: 5
    },
    {
        label: "Bạc Liêu",
        value: 6
    },
]


export const listTradeMark: TradeMarkType[] = [
    {
        name: "highlands",
        image: "/images/logo/highlands.png"
    },
    {
        name: "phuclong",
        image: "/images/logo/phuclong.png"
    },
    {
        name: "coopmart",
        image: "/images/logo/coopmart.png"
    },
    {
        name: "dingtea",
        image: "/images/logo/dingtea.png"
    },
    {
        name: "jollibee",
        image: "/images/logo/jollibee.png"
    },
    {
        name: "cgv",
        image: "/images/logo/cgv.png"
    },
    {
        name: "vascara",
        image: "/images/logo/vascara.png"
    },
    {
        name: "manuah",
        image: "/images/logo/manuah.png"
    },
    {
        name: "sulwhasoo",
        image: "/images/logo/dingtea.png"
    },
    {
        name: "levis",
        image: "/images/logo/levis.png"
    },
    {
        name: "br",
        image: "/images/logo/br.png"
    },
    {
        name: "kfc",
        image: "/images/logo/kfc.png"
    },
    {
        name: "galaxyplay",
        image: "/images/logo/galaxyplay.png"
    },
    {
        name: "go",
        image: "/images/logo/go.png"
    },
    {
        name: "starbucks",
        image: "/images/logo/starbucks.png"
    },
]


export const ViewTag:ViewTagProp[] = [
    {
        title:"Điểm voucher",
        value: "1"
    },
    {
        title:"Sản phẩm nổi bật",
        value: "2"
    },
]


export const listCard: CardType[] = [
    {
        id:1,
        name: "[E-voucher sản phẩm] KFC combo 5 Bánh Trứng",
        image: "/images/banner/test.png",
        price: '69000',
        priceOrigin: '89000',
        unit: 'VNDC',
        date: 60,
    },
    {
        id:2,
        name: "[E-voucher sản phẩm] KFC combo 5 Bánh Trứng",
        image: "/images/banner/test.png",
        price: '69000',
        priceOrigin: '89000',
        unit: 'VNDC',
        date: 60,
    },
    {
        id:3,
        name: "[E-voucher sản phẩm] KFC combo 5 Bánh Trứng",
        image: "/images/banner/test.png",
        price: '69000',
        priceOrigin: '89000',
        unit: 'VNDC',
        date: 60,
    },
    {
        id:4,
        name: "[E-voucher sản phẩm] KFC combo 5 Bánh Trứng",
        image: "/images/banner/test.png",
        price: '69000',
        priceOrigin: '89000',
        unit: 'VNDC',
        date: 60,
    },
    {
        id:5,
        name: "[E-voucher sản phẩm] KFC combo 5 Bánh Trứng",
        image: "/images/banner/test.png",
        price: '69000',
        priceOrigin: '89000',
        unit: 'VNDC',
        date: 60,
    },
    {
        id:6,
        name: "[E-voucher sản phẩm] KFC combo 5 Bánh Trứng",
        image: "/images/banner/test.png",
        price: '69000',
        priceOrigin: '89000',
        unit: 'VNDC',
        date: 60,
    },
    {
        id:7,
        name: "[E-voucher sản phẩm] KFC combo 5 Bánh Trứng",
        image: "/images/banner/test.png",
        price: '69000',
        priceOrigin: '89000',
        unit: 'VNDC',
        date: 60,
    },
]
